<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-4">
                <div class="row">
                    <div class="col-6">
                        <h5 class="text-xl-left font-weight-bold mr-2">HOTELS</h5>
                    </div>

                    <div class="col-6">
                        <button type="button" class="btn tnkc-primary" data-toggle="modal" data-target="#newHotelModal"  data-backdrop="static" data-keyboard="false">
                            <font-awesome-icon icon="plus" class="mr-2"/>
                            HOTEL / BLDG.
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <hr class="border-top">

        <div class="row mt-4">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-4 text-left" v-for="hotel in hotels" :key="hotel.id">
                        <div class="card bg-light mb-3">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col-md-6 font-weight-bold">
                                        <sup class="mr-1" v-bind:class="isActiveOrNot(hotel.status)">status</sup>
                                        <font-awesome-icon icon="circle" v-bind:class="isActiveOrNot(hotel.status)"/>
                                        {{hotel.code.toUpperCase()}}
                                    </div>
                                    <div class="col-md-6">
                                        <button type="button" class="btn btn-sm tnkc-primary mr-1" @click=view_hotel(hotel.id)>
                                            <font-awesome-icon icon="eye"/>
                                        </button>
                                        <button type="button" class="btn btn-sm tnkc-warning mr-1" @click="getHotelDetails(hotel.id)" data-toggle="modal" data-target="#hotelModal"  data-backdrop="static" data-keyboard="false">
                                            <font-awesome-icon icon="edit"/>
                                        </button>
                                        <button type="button" class="btn btn-sm tnkc-danger mr-1" @click="delete_hotel">
                                            <font-awesome-icon icon="trash"/>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-4">
                                        Floors:
                                    </div>
                                    <div class="col-4">
                                        Rooms:
                                    </div>
                                    <div class="col-4">
                                        Beds:
                                    </div>
                                </div>

                                <hr class="border">

                                <h6 class="card-title font-weight-bold p-0">" {{hotel.name.toUpperCase()}} "</h6>
                                <h6 class="card-title p-0">{{hotel.email}}</h6>
                                <p class="card-text" p-0>{{hotel.address}}</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!-- modal new hotel -->
        <div class="modal fade" id="newHotelModal" tabindex="-1" role="dialog" aria-labelledby="newHotelModalTitle" aria-hidden="true">
             <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <form @submit.prevent="create_hotel">
                        <div class="modal-header">
                            <h5 class="modal-title" id="newHotelModalTitle">HOTEL / BLDG. :</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div class="modal-body">
                            <div class="form-group text-left">
                                <label class="font-weight-bold" for="name">Hotel / Bldg. Name :</label>
                                <input type="text" id="newHotelName" class="form-control form-control-sm" placeholder="Bldg. Name" required v-model="newHotel.name">
                            </div>

                            <div class="form-group text-left">
                                <label class="font-weight-bold" for="email">Email :</label>
                                <input type="email" id="newHotelEmail" class="form-control form-control-sm" placeholder="Email" required v-model="newHotel.email">
                            </div>

                            <div class="form-group text-left">
                                <label class="font-weight-bold" for="address">Address :</label>
                                <input type="text" id="newHotelAddress" class="form-control form-control-sm" placeholder="Address" required v-model="newHotel.address">
                            </div>

                            <div class="form-group text-left">
                                <label class="font-weight-bold" for="newHotelStatus">Status :</label>
                                <input type="checkbox" id="newHotelStatus" class="form-check-label ml-3" placeholder="Status"  v-model="newHotel.status">
                            </div>

                        </div>

                        <div class="modal-footer">
                            <button type="submit" class="btn tnkc-primary">Save changes</button>
                            <button type="button" class="btn tnkc-secondary" data-dismiss="modal">Close</button>
                        </div>

                    </form>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="hotelModal" tabindex="-1" role="dialog" aria-labelledby="hotelModalTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <form @submit.prevent="update_hotel">
                        <div class="modal-header">
                            <h5 class="modal-title" id="hotelModalTitle">Update Details</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group text-left">
                                <label class="font-weight-bold" for="name">Hotel / Bldg. Name :</label>
                                <input type="text" id="name" class="form-control form-control-sm" placeholder="Bldg. Name" required v-model="hotel.name">
                            </div>

                            <div class="form-group text-left">
                                <label class="font-weight-bold" for="email">Email :</label>
                                <input type="email" id="email" class="form-control form-control-sm" placeholder="Email" required v-model="hotel.email">
                            </div>

                            <div class="form-group text-left">
                                <label class="font-weight-bold" for="address">Address :</label>
                                <input type="text" id="address" class="form-control form-control-sm" placeholder="Address" required v-model="hotel.address">
                            </div>

                            <div class="form-group text-left">
                                <label class="font-weight-bold" for="status">Status :</label>
                                <input type="checkbox" id="status" class="form-check-label ml-3" placeholder="Status"  v-model="hotel.status">
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="submit" class="btn tnkc-primary">Save changes</button>
                            <button type="button" class="btn tnkc-secondary" data-dismiss="modal">Close</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters,mapActions} from 'vuex';
    import {appMixins} from '../../../mixins/app.mixins';

  export default {
    name: 'Hotel',
    mixins:[appMixins],
    data(){
      return{}
    },

    methods: {
      ...mapActions(['getHotels','createHotel','viewHotel','updateHotel','setNullRoom','setNullFloor','getHotelKeyDetails','getAllHotelFloors']),

      view_hotel(id){
        // view hotel record with , floor ,roooms, and bed details .
        this.$router.push({name: 'HotelDetails', params: {id: id}}).catch(err=>{});
      },

     async create_hotel(){
       let msg = 'Are you sure you want to add this record.';
       let actionType = 'Add Hotel Record';
        if( await this.questionAlert(`${msg}`,`${actionType}`)){
          this.createHotel(this.newHotel).then((res)=>{
            if(res==true){
              this.successAlert('Creating new hotel record successfully','Create Hotel Record');
              this.getAllHotelFloors();
            }
          });
        }
      },

      getHotelDetails(id){
        this.viewHotel(id);
      },

      async update_hotel(){
        let msg = 'Are you sure you want to edit this record.';
        let actionType = 'Edit Hotel Record';
        if(await this.questionAlert(`${msg}`,`${actionType}`)){
         this.updateHotel(this.hotel).then((res)=>{
           if(res == true){
             this.successAlert('Update hotel details successfully.','Update Hotel Details');
             this.getAllHotelFloors();
             this.getHotelKeyDetails();
           }
         });
        }
      },

      async delete_hotel(){
        let msg = 'Are you sure you want to delete all the records of this hotel.';
        let actionType = 'Delete Hotel Record';
        let icon = 'warning';
        if(await this.questionAlert(`${msg}`,`${actionType}`,`${icon}`)){
          alert('proceed to delete');
        }
      },

      isActiveOrNot(object){
        return object ? 'tnkc-success-text' : 'tnkc-danger-text';
      }
    },

    computed:{
      ...mapGetters(['hotels','newHotel','hotel']),
    },

   created() {
     this.getHotels();
      //create
      //view
      //update
      //delete
    },

    mounted() {

    },

    destroyed() {
      this.setNullRoom();
      this.setNullFloor();
    }

  };
</script>

<style scoped>
    input[type=checkbox] {
        transform: scale(2);
    }

</style>
